import React, {
	memo
}from 'react'
import {
	Skeleton, Tooltip, Row, Col
}from 'antd'
import SignedIcon from "../../../../public/signedIcon.png"
import i18n from './localization'
import CRUDIcons from '../../../components/CRUDIcons'
import './style.css'

const AppealFiles = memo(({
	reOrgAppeal, isRu, fileList, downloadMethod, downloadAllMethod
}) => {

	return (
		<>
			{ fileList != null ? (
				fileList.length ? (
					<>
						<Row>
							<Col md={12}>
								{`${i18n.appealFiles[isRu] }:`}
							</Col>
							{fileList?.length>1 && downloadAllMethod != null &&
							<Col 
								className={"downloadAllAppealsFiles"}
								onClick={ () => { downloadAllMethod(reOrgAppeal.id, i18n.downloadAppealsZipFileName[isRu].replace('{0}', reOrgAppeal.appeal.regNumber))}}
							>
									<Tooltip className="downloadAllAppealsFiles" title={i18n.promptTextForDownloadAppealsZipFile[isRu]}>
										<Row>
											<Col>
												{CRUDIcons.download(null, "svg_download")}
											</Col>
											<Col>
												{i18n.downloadAppealsFiles[isRu]}
											</Col>
										</Row>
									</Tooltip>
							</Col>} 
						</Row>
						<div>
							{ fileList.map((item) => {
								return (
									<div
										key={ `appealFile_${ item.id }` }
										className="custom-file"
									>
										{item.signerInfo &&
											<Tooltip  
												title={i18n.signer[isRu].format(item.signerInfo)}
												overlayInnerStyle={{ whiteSpace: 'pre-line' }}
												className='signer_icon'
											>
												<img src={SignedIcon} width={20} height={20} style={{verticalAlign: "middle", marginRight: "3px"}}/>
											</Tooltip>
										}
										<Tooltip
											placement="left"
											title={ item.fileName + item.fileExtension }
										>
											<a onClick={ () => downloadMethod(item) }>
												{ item.fileName + item.fileExtension }
											</a>
										</Tooltip>
									</div>
								)
							}) }
						</div>
					</>
				) : null
			) : (
				<Skeleton
					active
					loading
				/>
			) }
		</>
	)
})

export default AppealFiles